import React from "react";


// Sanitizer - keine script oder onclick, Sicherheit und so

function sanitizeHTML(input) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(input, "text/html");
  
    // Remove <script> and <style> tags
    doc.querySelectorAll("script, style").forEach(el => el.remove());
  
    // Remove inline event handlers (onclick, onerror, etc.)
    doc.querySelectorAll("*").forEach(el => {
      [...el.attributes].forEach(attr => {
        if (attr.name.startsWith("on")) el.removeAttribute(attr.name);
      });
    });
  
    return doc.body.innerHTML;
  }
  
  /**
   * SafeDisplayText
   * - Takes raw HTML (e.g. from Tiptap)
   * - Sanitizes it
   * - Renders it as real HTML (not escaped)
   */
  export default function SafeDisplayText({ html, className }) {
    if (!html) return null;
  
    const cleanHTML = sanitizeHTML(html);
  
    return (
      <div
        className={className || "editor-content"}
        dangerouslySetInnerHTML={{ __html: cleanHTML }}
      />
    );
  }